export const PORTAL_TICKET_ACCESS_COLLECTION = "patientPortalTicketAccessEmails";
export const PORTAL_TICKETS_COLLECTION = "patientPortalTickets";
export const PORTAL_TICKET_TYPES = [
  { id: "sleep-test", label: "Sleep Test", prefix: "SB", icon: "fa-bed" },
  { id: "cpap", label: "CPAP Support", prefix: "CP", icon: "fa-medkit" },
  { id: "consult", label: "Sleep Consultation", prefix: "SC", icon: "fa-comments" },
];
export const PORTAL_TICKET_STATUSES = {
  requested: { label: "Pending approval", badge: "warning" },
  confirmed: { label: "Approved", badge: "primary" },
  completed: { label: "Completed", badge: "success" },
  cancelled: { label: "Cancelled", badge: "secondary" },
};
export const portalTicketTypeLabel = (id) => {
  const type = PORTAL_TICKET_TYPES.find((item) => item.id === id);
  return type ? type.label : id;
};
export const normalizePortalTicketEmail = (value) => String(value || "").trim().toLowerCase();
export const validPortalTicketEmail = (value) => /^[^\s@/]+@[^\s@/]+\.[^\s@/]+$/.test(normalizePortalTicketEmail(value));
export const portalTicketTypesFromAccess = (data) => PORTAL_TICKET_TYPES
  .map((type) => type.id)
  .filter((id) => data && Array.isArray(data.ticketTypes) && data.ticketTypes.includes(id));
export const isActivePortalTicket = (ticket) => ["requested", "confirmed"].includes(ticket.status);
export const portalTicketTransitions = (status) => ({ requested: ["confirmed", "cancelled"], confirmed: ["completed", "cancelled"] }[status] || []);
export const portalTicketPatientName = (ticket) => ticket.name || [ticket.firstname, ticket.lastname].filter(Boolean).join(" ") || "—";
const ticketText = (value) => typeof value === "string" ? value.trim() : "";
const homeAddressFields = [
  ["houseNumber", "บ้านเลขที่"], ["building", "อาคาร / หมู่บ้าน"], ["floor", "ชั้น"], ["room", "ห้อง"],
  ["soi", "ซอย"], ["road", "ถนน"], ["subdistrict", "ตำบล / แขวง"], ["district", "อำเภอ / เขต"], ["province", "จังหวัด"], ["postcode", ""],
];
const separateHomeAddress = (ticket) => ticket.homeFullAddress !== undefined || ticket.homeAddressFields !== undefined;
export const portalTicketHomeAddress = (ticket) => {
  const summary = ticketText(ticket.homeFullAddress);
  if (summary) return summary;
  const fields = ticket.homeAddressFields || {};
  const formatted = homeAddressFields.map(([key, label]) => {
    const value = ticketText(fields[key]);
    return value ? [label, value].filter(Boolean).join(" ") : "";
  }).filter(Boolean).join(" ");
  return formatted || (!separateHomeAddress(ticket) ? ticketText(ticket.homeAddress) : "");
};
export const portalTicketHomeAddressNote = (ticket) => separateHomeAddress(ticket) ? ticketText(ticket.homeAddress) : "";
export const portalTicketSleepStudyTypeLabel = (ticket) => {
  if (ticket.serviceId !== "sleep-test") return "";
  if (ticket.studyLocation === "home") return "Full Night Sleep Study";
  // Portal hospital requests before the type selector were full-night studies.
  const type = ticket.sleepStudyType === undefined ? "full-night" : ticket.sleepStudyType;
  return ({ "full-night": "Full Night Sleep Study", "split-night": "Split Night Sleep Study", unsure: "ยังไม่แน่ใจ — ให้เจ้าหน้าที่ติดต่อกลับ" })[type] || "—";
};
export const portalTicketSleepLocation = (ticket) => {
  if (ticket.serviceId !== "sleep-test") return { label: "", value: "—" };
  if (ticket.studyLocation === "home") return { label: "Home study", value: portalTicketHomeAddress(ticket) || "—" };
  return { label: "Hospital / clinic", value: ticketText(ticket.hospitalName) || ticketText(ticket.location) || "—" };
};
export const PORTAL_CALLBACK_HOURS = "Mon–Fri, 09:00–18:00 (Thailand time)";
const isStaffCallback = (ticket) => ["cpap", "consult"].includes(ticket.serviceId)
  && ((ticket.consultSupport || ticket.cpapSupport) === "staff"
    || (ticket.serviceId === "consult" && (ticket.consultSupport || ticket.cpapSupport) !== "hospital"));
export const portalTicketDateLabel = (ticket) => {
  if (ticket.serviceId === "sleep-test") return "Study date";
  if (["cpap", "consult"].includes(ticket.serviceId) && (ticket.consultSupport || ticket.cpapSupport) === "hospital") return "OPD date";
  return isStaffCallback(ticket) ? "Preferred callback date" : "Requested date";
};
export const portalTicketDateValue = (ticket) => (typeof ticket.date === "string" && ticket.date.trim())
  || (isStaffCallback(ticket) ? "No date preference" : "—");
const callbackRange = /^((?:[01]\d|2[0-3]):[0-5]\d)\s*[-–]\s*((?:[01]\d|2[0-3]):[0-5]\d)$/;
export const portalTicketCallbackTimes = (value) => {
  if (typeof value !== "string" || !value.trim()) return [];
  if (value.trim() === "anytime") return ["Any time during working hours"];
  return value.split(",").map(part => part.trim()).filter(Boolean).map(part => {
    const range = part.match(callbackRange);
    // Preserve older point times and free-text preferences as saved.
    return range ? `${range[1]}–${range[2]}` : part;
  });
};
export const filterPortalTickets = (tickets, { type = "", status = "active", search = "" } = {}) => {
  const term = search.trim().toLowerCase();
  return tickets.filter((ticket) => (!type || ticket.serviceId === type)
    && (!status || (status === "active" ? isActivePortalTicket(ticket) : ticket.status === status))
    && (!term || [ticket.reference, ticket.hn, portalTicketPatientName(ticket), ticket.phone, ticket.bookingOrder]
      .some((value) => String(value || "").toLowerCase().includes(term))));
};
export const portalTicketTime = (value) => value && typeof value.toMillis === "function" ? value.toMillis() : 0;
